import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const About = () => {
  useEffect(() => {
    document.title = "About - Deww Botanicals";
  }, []);

  const location = useLocation();
  const currentUrl = location.pathname;

  // Check if the URL contains a specific word
  const shouldShowElement = currentUrl.includes("about");

  return (
    <>
      {/* // Page Header Start */}
      {shouldShowElement && (
       <div className="container-fluid page-header position-relative banner_video overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="position-absolute w-100 h-100 object-fit-cover"
          style={{ top: 0, left: 0, zIndex: -1 }}
        >
          <source src="../assets/about_us.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
          <div className="container">
            <h1 className="display-5 mb-3 animated slideInDown">
              About Company
            </h1>
            <nav aria-label="breadcrumb animated slideInDown">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <span className="text-body">Home</span>
                </li>
                <li
                  className="breadcrumb-item text-dark active"
                  aria-current="page"
                >
                  About Company
                </li>
              </ol>
            </nav>
          </div>
        </div>
      )}
      {/* // Page Header End */}

      {shouldShowElement && (
        <div className="container-xxl py-3 container-fluid p-0 mb-5 wow fadeIn d-none">
          <div className="container">
            <div className="row g-5 align-items-center">
              <div className="col-lg-6 wow fadeIn">
                <div className="about-img position-relative overflow-hidden p-5 pe-0">
                  <img
                    alt="Deww Botanicals"
                    className="img-fluid w-100 rounded"
                    src="../assets/images/about.jpg"
                  />
                </div>
              </div>
              <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                <h1 className="section-heading">About Us</h1>
                <p className="text-justify">
                  Deww Botanicals is a premier essential and carrier oil company
                  dedicated to providing high-quality, natural oils for
                  aromatherapy, personal care, and wellness. Known for their
                  commitment to sustainability and purity, Deww Botanicals oﬀers
                  a diverse range of products, including essential oils
                  extracted from plants through ethical practices and carrier
                  oils that are meticulously sourced to ensure optimal
                  therapeutic benefits.
                </p>

                <p>
                  The company emphasizes transparency, sourcing directly from
                  reputable growers, and rigorous quality control to deliver
                  oils that are potent, safe, and free from synthetic additives.
                  Deww Botanicals is the go-to choice for both individuals and
                  professionals seeking authentic, eco-friendly oil products.
                </p>
                <h1 className="section-heading mt-5">Why Us?</h1>
                <p>
                  Choosing Deww Botanicals for your essential and carrier oils
                  ensures you receive premium, 100% pure products sourced
                  ethically and sustainably. Our rigorous quality control
                  guarantees potency and safety, while transparent sourcing
                  practices oﬀer confidence in product authenticity. With a
                  diverse range of oils, eco-friendly packaging, and excellent
                  customer support, Deww Botanicals is a trusted choice for both
                  personal and professional wellness needs.
                </p>

                {!shouldShowElement && (
                  <a
                    className="btn btn-primary py-3 px-5 mt-3"
                    Using target="_blank" without rel="noreferrer"
                    href="/about"
                  >
                    {" "}
                    Read More
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {!shouldShowElement && ( */}
      <div className="container-fluid p-0 bg-theme-light">
        <div className="row m-0">
          <div className={shouldShowElement ? 'col-12 col-md-6 p-0 order-2 order-md-1' : 'col-12 col-md-5 p-0 order-2 order-md-1'}>
            <div className="about-img position-relative overflow-hidden p-0 h-100">
              <img
                alt="Deww Botanicals"
                className="img-fluid w-100 h-100"
                src="../assets/images/about.jpg"
              />
            </div>
          </div>
          <div className={shouldShowElement ? 'col-12 col-md-6 p-0 d-flex align-items-center justify-content-start order-1 order-md-2' : 'col-12 col-md-7 p-0 d-flex align-items-center justify-content-start order-1 order-md-2'}>
            <div className="content-wrap px-3 py-4 p-md-5">
              <h1 className="section-heading text-primary">About Us</h1>
              <p className="text-justify text-primary">
                Deww Botanicals is a premier essential and carrier oil company
                dedicated to providing high-quality, natural oils for
                aromatherapy, personal care, and wellness. Known for their
                commitment to sustainability and purity, Deww Botanicals oﬀers a
                diverse range of products, including essential oils extracted
                from plants through ethical practices and carrier oils that are
                meticulously sourced to ensure optimal therapeutic benefits.
              </p>

              <p className="text-primary">
                The company emphasizes transparency, sourcing directly from
                reputable growers, and rigorous quality control to deliver oils
                that are potent, safe, and free from synthetic additives. Deww
                Botanicals is the go-to choice for both individuals and
                professionals seeking authentic, eco-friendly oil products.
              </p>
              <h1 className="section-heading mt-5 text-primary">Why Us?</h1>
              <p className="text-primary">
                Choosing Deww Botanicals for your essential and carrier oils
                ensures you receive premium, 100% pure products sourced
                ethically and sustainably. Our rigorous quality control
                guarantees potency and safety, while transparent sourcing
                practices oﬀer confidence in product authenticity. With a
                diverse range of oils, eco-friendly packaging, and excellent
                customer support, Deww Botanicals is a trusted choice for both
                personal and professional wellness needs.
              </p>
              </div>
              </div>
              </div>

              {shouldShowElement && (
                <div className="row m-0">
                  <div className={shouldShowElement ? 'col-12 col-md-6 p-0 d-flex align-items-center justify-content-start' : 'col-12 col-md-5 p-0 d-flex align-items-center justify-content-start'}>
                    <div className="content-wrap px-3 py-4 p-md-5">
                      <h1 className="section-heading mt-5 text-primary">
                        Vision
                      </h1>
                      <p className="text-primary">
                        Deww Botanicals envisions a world where natural,
                        high-quality essential and carrier oils are accessible
                        to everyone, promoting holistic wellness and
                        environmental sustainability. We strive to be a global
                        leader in the essential oil industry, setting the
                        standard for purity, ethical sourcing, and eco-conscious
                        practices.
                      </p>
                      <h1 className="section-heading mt-5 text-primary">
                        Mission
                      </h1>
                      <p className="text-primary">
                        Deww Botanicals is dedicated to providing exceptional
                        essential and carrier oils that enhance well-being and
                        support a healthier planet. We are committed to
                        sustainable sourcing, rigorous quality control, and
                        transparency, ensuring their products are safe, pure,
                        and beneficial. Through education and innovation, we aim
                        to inspire and empower individuals and professionals to
                        integrate natural oils into their daily lives for
                        optimal health and happiness.
                      </p>
                    </div>
                  </div>

                  <div className={shouldShowElement ? 'col-12 col-md-6 p-0' : 'col-12 col-md-5 p-0'}>
                    <div className="about-img position-relative overflow-hidden p-0 h-100">
                      <img
                        alt="Deww Botanicals"
                        className="img-fluid w-100 h-100"
                        src="../assets/images/mission-vision.jpg"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
      {/* )} */}
    </>
  );
};

export default About;
